export default "<div class=\"app-LandingPage\"></div>\n"